"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListOverrides = void 0;
var createMuiListOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        padding: {
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
        },
    });
};
exports.createMuiListOverrides = createMuiListOverrides;
//# sourceMappingURL=MuiList.js.map